export default {
  ROLE_PARTNER_SELLER: {
    // Услуги
    CHATS: {
      READ: false,
      BUTTONS: false,
      MENU: false,
    },
    // Сублимиты
    SUBLIMITS: {
      READ: false,
    },
    // 1 seller
    DASHBOARD: {
      READ: true,
      ANALYTICS: false,
    },
    TERMINATION: {
      READ: true,
      CREATE: true,
      PRINT: true,
    },
    TERMINATIONS_LIST: {
      READ: false,
      PRINT: false,
    },
    INSURANCE: {
      READ: true,
      CREATE: true,
      PRINT: true,
    },
    CONTRACT: {
      READ: true,
      PRINT: true,
      CREATE: true,
      EDIT: true,
      // WITHDRAWAL: true,
    },
    CONTRACTS_LIST: {
      READ: true,
      PRINT: false,
    },
    CONTRACTS_LIST_TOTAL: { READ: false },
    SEARCH: {
      READ: true,
      CONTRACT: true,
      OFFERTERMS: true,
      EXPRESSPAYMENT: true,
      INSURANCE: true,
    },
    EXPRESSPAYMENT: {
      PAY: false,
      ALERT: true,
    },
    ACTS: {
      READ: false,
      PRINT: false,
      CREATE: false,
    },
    INSURANCE_LIST: {
      READ: false,
      PRINT: false,
    },
    INSURANCE_DETAILS: {
      READ: false,
      PRINT: false,
    },
    HELP: {
      READ: true,
    },
    SETTINGS: {
      READ: true,
    },
    USER_CARD: {
      READ: true,
      NAME: true,
      PASSWORD: true,
    },
    USERS_ACTIVITIES: {
      READ: false,
    },
    DEPARTMENTS: {
      READ: false,
    },
    INSURANCE_PROGRAMS: {
      READ: false,
    },
    ACCESS_POLICY: {
      READ: false,
    },
    INSURANCE_COMPANY: {
      READ: false,
    },
    PROCESS_ANALYTICS: {
      READ: false,
    },
    TELEGRAM: {
      READ: true,
    },
    WIKI: {
      READ: true,
    },
    SALE_POINTS: {
      READ: false,
    },
  },
};
